import React from 'react';
import BaseChart from './BaseChart';
import { EChartsOption } from 'echarts';

interface LineChartProps {
  data: {
    name: string;
    data: number[];
  }[];
  xAxisData: string[];
  title?: string;
  className?: string;
  loading?: boolean;
}

const LineChart: React.FC<LineChartProps> = ({
  data,
  xAxisData,
  title,
  className,
  loading = false
}) => {
  const option: EChartsOption = {
    title: {
      text: title,
      textStyle: {
        color: '#1f2937',
        fontSize: 16
      }
    },
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      textStyle: {
        color: '#1f2937'
      }
    },
    legend: {
      data: data.map(item => item.name),
      textStyle: {
        color: '#1f2937'
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: xAxisData,
      axisLine: {
        lineStyle: {
          color: '#d1d5db'
        }
      },
      axisLabel: {
        color: '#6b7280'
      }
    },
    yAxis: {
      type: 'value',
      axisLine: {
        lineStyle: {
          color: '#d1d5db'
        }
      },
      axisLabel: {
        color: '#6b7280'
      },
      splitLine: {
        lineStyle: {
          color: '#d1d5db'
        }
      }
    },
    series: data.map((item, index) => ({
      name: item.name,
      type: 'line',
      data: item.data,
      smooth: true,
      lineStyle: {
        width: 2
      },
      itemStyle: {
        color: ['#3B82F6', '#10B981', '#F59E0B', '#EF4444'][index % 4]
      }
    }))
  };

  return (
    <BaseChart
      option={option}
      className={className}
      loading={loading}
    />
  );
};

export default LineChart;